module.exports = {
  watchdog: {
    languages: {
      en: 'English',
      nl: 'Nederlands',
      fr: 'Francais'
    },

    title:{
      text:'Watchdog',
      info:'Watchdog toont de status van iedere Onsophic service als ook de laatste updates van het systeem.'
    },
    alert:{
      warning:{
        title:'Sorry!',
        info:'Het lijkt alsof we op dit moment enkele problemen hebben, je kan hieronder de status bekijken in de logs.'
      },
      success:{
        title:'Top!',
        info:'Onze systemen vertonen geen probleem, veel studieplezier.'
      },
      danger:{
        title:'Sorry!',
        info:'We hebben enkele problemen in sommige van onze systemen, we zoeken naar de oplossing. Check de logs voor meer informatie. '
      }
    },
    services:{
      event:{
        title:"Event processor",
        info:"Dit is de event processor"
      },
      api:{
        title:"API",
        info:"Dit is de API"
      },
      webapp:{
        title:"Web applicatie",
        info: "Dit is de web applicatie"
      }
    }
  }
};


/** WEBPACK FOOTER **
 ** ./src/languages/nl.js
 **/